import React from 'react';
import { Link } from 'react-router-dom';

const NotFound = () => {
  return (
    <div style={{ padding: '40px', textAlign: 'center' }}>
      <h1>404</h1>
      <p>Page not found</p>

      <Link to="/">⬅ Go back home</Link>
    </div>
  );
};

export default NotFound;
